(() => {
  const visible = el => {
    if (el.closest('[hidden]') || el.type === 'hidden') return false;
    const style = getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return !!el.getClientRects().length;
  };
  const prepare = form => {
    if (!form) return;
    const fields = form.querySelector('[data-dope-fields]');
    if (!fields) return;
    // Easify inserts its text fields after the theme's fields; keep the note below both.
    const requiredNote = form.querySelector('[data-dope-required-note]');
    const purchaseControls = form.querySelector('[ref="productFormButtons"]');
    if (requiredNote && purchaseControls && requiredNote.nextElementSibling !== purchaseControls) {
      purchaseControls.before(requiredNote);
    }
    const custom = fields.querySelector('[data-dope-custom]');
    if (custom) {
      const scope = form.closest('.shopify-section') || form;
      const selected = [...scope.querySelectorAll('variant-picker input:checked,variant-picker select option:checked')].map(x => x.value).join(' ');
      const enabled = /(?:^|\s)(?:Sì|Si|Yes|Oui)(?:\s|\(|$)/i.test(selected);
      custom.hidden = !enabled;
      custom.querySelectorAll('[data-dope-conditional]').forEach(el => {el.disabled = !enabled;el.required = enabled;});
    }
    const phone = fields.querySelector('[data-dope-phone]');
    const existing = [...form.querySelectorAll('input[name^="properties["]')].find(el => !fields.contains(el) && /telefon|phone/i.test(el.name) && visible(el));
    phone.hidden = !!existing;
    phone.querySelector('input').disabled = !!existing;
    phone.querySelector('input').required = !existing;
    if (existing) {existing.required = true;existing.type = 'tel';existing.autocomplete = 'tel';}
    const standard = fields.querySelector('[data-dope-standard]');
    if (standard) {
      const enabled = !custom || custom.hidden;
      standard.hidden = !enabled;
      standard.querySelectorAll('input').forEach(el => { el.disabled = !enabled; el.required = enabled; });
      const chosen = standard.querySelector('input:checked');
      if (enabled && chosen && standard.dataset.previewMedia !== chosen.dataset.dopeMediaId) {
        const gallery = (form.closest('.shopify-section') || form).querySelector('media-gallery');
        const slideshow = gallery?.querySelector('slideshow-component');
        const index = [...(gallery?.querySelectorAll('slideshow-slide') || [])].findIndex(slide => slide.querySelector('[data-media-id="' + chosen.dataset.dopeMediaId + '"]'));
        if (index >= 0 && typeof slideshow?.select === 'function') {
          slideshow.select(index, undefined, {animate: !matchMedia('(prefers-reduced-motion: reduce)').matches});
          standard.dataset.previewMedia = chosen.dataset.dopeMediaId;
        }
      }
    }
    fields.querySelectorAll('fieldset').forEach(group => {
      const caption = group.querySelector('[data-color-value]');
      if (!caption) return;
      const selected = group.querySelector('input[type="radio"]:checked:not(:disabled)');
      const text = selected ? '— ' + (selected.dataset.colorLabel || selected.value) : '';
      if (caption.textContent !== text) caption.textContent = text;
    });
    [...form.elements].filter(el => el.matches?.('input[name^="properties["],textarea[name^="properties["],select[name^="properties["],.tpo_option-input,.tpo_color-swatches-input')).forEach(el => {
      if (el.type === 'hidden' || el.name?.startsWith('properties[_') || el.classList.contains('tpo_hidden-checkbox')) return;
      el.removeAttribute('minlength');
      if (el.matches('textarea,input[type="text"],input[type="tel"]')) el.removeAttribute('pattern');
      if (el.matches('[data-dope-conditional],[data-dope-standard-color]') || el.closest('[data-dope-phone]')) return;
      const configured = el.getAttribute('data-required');
      if (el.dataset.dopeOriginalRequired === undefined && configured === null) el.dataset.dopeOriginalRequired = String(el.required);
      const required = configured === null ? el.dataset.dopeOriginalRequired === 'true' : configured === '1' || configured === 'true';
      el.required = !el.disabled && visible(el) && required;
    });
  };
  window.dopeValidateProduct = form => {
    if (!form) return false;
    prepare(form);
    const fields = form.querySelector('[data-dope-fields]');
    const error = fields?.querySelector('[data-dope-error]');
    if (error) error.hidden = true;
    const controls = [...form.elements].filter(el => !el.disabled && el.type !== 'hidden' && (el.name?.startsWith('properties[') || el.matches('.tpo_option-input,.tpo_color-swatches-input')) && !el.classList.contains('tpo_hidden-checkbox') && !el.name?.startsWith('properties[_'));
    for (const el of controls) {
      const shown = visible(el);
      if (!shown || !el.required) continue;
      const missing = el.type === 'checkbox' ? !el.checked : el.type === 'radio' ? !controls.some(x => x.name === el.name && x.checked) : !el.value.trim();
      if (missing || !el.checkValidity()) {
        if (error) {error.textContent = fields.dataset.requiredError;error.hidden = false;}
        el.scrollIntoView({block:'center',behavior:'smooth'});el.focus();el.reportValidity();return false;
      }
    }
    return form.reportValidity();
  };
  const translations = JSON.parse(document.querySelector('[data-dope-translations]')?.textContent || '{}');
  const refresh = () => {
    document.querySelectorAll('product-form-component form').forEach(prepare);
    document.querySelectorAll('.tpo_option-set-container *,.tpo-swatch-option-label').forEach(el => {
      ['placeholder','aria-label','title'].forEach(attribute => {
        const original = el.getAttribute(attribute);
        const translated = translations[original?.trim()];
        if (translated && translated !== original) el.setAttribute(attribute, translated);
      });
      el.childNodes.forEach(node => {
        if (node.nodeType !== Node.TEXT_NODE) return;
        const translated = translations[node.textContent.replace(/\s+/g, ' ').trim()];
        if (translated && translated !== node.textContent.trim()) node.textContent = node.textContent.replace(node.textContent.trim(), translated);
      });
    });
  };
  let selectionEpoch = 0;
  document.addEventListener('shopify:product:select', async event => {
    const epoch = ++selectionEpoch;
    const scope = event.target.closest('.shopify-section') || document;
    try { await event.promise; } catch { return; }
    if (epoch !== selectionEpoch) return;
    requestAnimationFrame(() => {
      if (epoch !== selectionEpoch) return;
      scope.querySelectorAll('[data-dope-standard]').forEach(el => { delete el.dataset.previewMedia; });
      refresh();
    });
  });
  document.addEventListener('change', event => {
    const radio = event.target;
    if (radio.matches('[data-dope-conditional][type=radio],[data-dope-fork-color]')) {
      const value = radio.closest('fieldset')?.querySelector('[data-color-value]');
      if (value) value.textContent = '— '+(radio.dataset.colorLabel || radio.value);
    }
    refresh();
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (form.matches('product-form-component form') && !window.dopeValidateProduct(form)) {event.preventDefault();event.stopImmediatePropagation();}
  },true);
  document.addEventListener('click', event => {
    const checkout = event.composedPath().find(el => el instanceof Element && el.matches('.shopify-payment-button,shopify-accelerated-checkout,.accelerated-checkout-block'));
    if (!checkout) return;
    const form = checkout.closest('form');
    if (form && !window.dopeValidateProduct(form)) {event.preventDefault();event.stopImmediatePropagation();}
  },true);
  let pending = false;
  new MutationObserver(records => {
    if (pending || !records.some(r => r.addedNodes.length)) return;
    pending = true;requestAnimationFrame(() => {pending=false;refresh();});
  }).observe(document.documentElement,{childList:true,subtree:true});
  refresh();
})();





/* Full-custom material samples stay separate from product media. */
(() => {
  const samples = {
  "white-gloss": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-white-gloss-v1.png?v=1792242629&width=224",
  "white-matte": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-white-matte-v1.png?v=1792242641&width=224",
  "white-glitter": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-white-glitter-v1.png?v=1792242651&width=224",
  "white-prism": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-white-prism-v1.png?v=1792242662&width=224",
  "white-ice": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-white-ice-v1.png?v=1792242640&width=224",
  "white-bloom": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-white-bloom-v1.png?v=1792242654&width=224",
  "mixed-gloss": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-mixed-gloss-v2.png?v=1792272637&width=224",
  "mixed-matte": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-mixed-matte-v2.png?v=1792272648&width=224",
  "mixed-glitter": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-mixed-glitter-v2.png?v=1792272666&width=224",
  "mixed-prism": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-mixed-prism-v2.png?v=1792272681&width=224",
  "mixed-ice": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-mixed-ice-v2.png?v=1792272691&width=224",
  "mixed-bloom": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-mixed-bloom-v2.png?v=1792272700&width=224",
  "holo-gloss": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-holo-gloss-v2.png?v=1792272901&width=224",
  "holo-matte": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-holo-matte-v2.png?v=1792272912&width=224",
  "holo-glitter": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-holo-glitter-v2.png?v=1792272927&width=224",
  "holo-prism": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-holo-prism-v2.png?v=1792272944&width=224",
  "holo-ice": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-holo-ice-v2.png?v=1792272955&width=224",
  "holo-bloom": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-holo-bloom-v2.png?v=1792272965&width=224",
  "chrome-gloss": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-chrome-gloss-v2.png?v=1792273476&width=224",
  "chrome-matte": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-chrome-matte-v2.png?v=1792273489&width=224",
  "chrome-glitter": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-chrome-glitter-v2.png?v=1792273514&width=224",
  "chrome-prism": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-chrome-prism-v2.png?v=1792273525&width=224",
  "chrome-ice": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-chrome-ice-v2.png?v=1792273535&width=224",
  "chrome-bloom": "https://cdn.shopify.com/s/files/1/0986/4206/7720/files/dope-material-chrome-bloom-v2.png?v=1792273546&width=224"
};
  const bases = {'Base brillante':'white','Base holographique':'holo','Base chromée':'chrome','Détails holographiques/chromés/fluo':'mixed','Gloss Base':'white','Glossy Base':'white','Holographic/Chrome/Fluorescent Details':'mixed','Holographic Base':'holo','Chrome Base':'chrome','Base Lucida':'white','Dettagli Holografici/Chromati/Fluo':'mixed','Base Holografica':'holo','Base Chromo':'chrome','Base Chrome':'chrome'};
  const finishes = {'Lamination brillante':'gloss','Lamination mate':'matte','Paillettes multicolores':'glitter','Effet prisme':'prism','Effet givré':'ice','Effet Bloom':'bloom','Gloss Lamination':'gloss','Matte Lamination':'matte','Multicolor Glitter':'glitter','Multicolour Glitter':'glitter','Prism Effect':'prism','Iced Effect':'ice','Ice Effect':'ice','Bloom Effect':'bloom','Laminazione Lucida':'gloss','Laminazione Opaca':'matte','Glitter Multicolore':'glitter','Effetto Prisma':'prism','Effetto Ghiacciato':'ice','Effetto Bloom':'bloom'};
  const refresh = () => {
    const visited = new Set();
    document.querySelectorAll('template[data-dope-material-template]').forEach(template => {
      const scope = template.closest('.shopify-section');
      if (!scope || visited.has(scope)) return;
      visited.add(scope);
      const picker = scope.querySelector('variant-picker');
      if (!picker) return;
      let panel = scope.querySelector('[data-dope-material-preview]');
      if (!panel) {
        panel = template.content.cloneNode(true).querySelector('[data-dope-material-preview]');
        if (!panel) return;
        picker.insertAdjacentElement('afterend', panel);
      }
      const groups = [...picker.querySelectorAll('fieldset')];
      const selections = groups.length ? groups.map(group => group.querySelector('input:checked')?.value) : [...picker.querySelectorAll('select')].map(select => select.value);
      const aliases = {'Base lucida':'Base Lucida','HOLO':'Base Holografica','CHROMO':'Base Chromo','Lucido':'Laminazione Lucida','Opaco':'Laminazione Opaca','glitter':'Glitter Multicolore'};
      const [base, finish] = selections.map(value => aliases[value] || value);
      const key = bases[base] + '-' + finishes[finish];
      const source = samples[key];
      panel.hidden = !source;
      if (!source) return;
      const translations = JSON.parse(document.querySelector('[data-dope-translations]')?.textContent || '{}');
      const caption = (translations[base] || base) + ' · ' + (translations[finish] || finish);
      const image = panel.querySelector('img');
      const label = panel.querySelector('[data-dope-material-label]');
      if (image.getAttribute('src') !== source) image.setAttribute('src', source);
      if (image.alt !== (panel.dataset.samplePrefix || '') + caption) image.alt = (panel.dataset.samplePrefix || '') + caption;
      if (label.textContent !== caption) label.textContent = caption;
      if (panel.dataset.sampleKey !== key) panel.dataset.sampleKey = key;
    });
  };
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; refresh(); });
  };
  document.addEventListener('change', event => {
    if (event.target instanceof Element && event.target.closest('variant-picker')) schedule();
  });
  let selectionEpoch = 0;
  document.addEventListener('shopify:product:select', async event => {
    const epoch = ++selectionEpoch;
    try { await event.promise; } catch { return; }
    if (epoch === selectionEpoch) schedule();
  });
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(records => {
    if (records.some(record => record.addedNodes.length || record.removedNodes.length)) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
  refresh();
})();


